import React from 'react';
import { Link } from "react-router-dom";

export default function ContainedButtons(props) {
  return (
    <div className="button-wrapper">
      <Link className="app-button app-button-primary" to={ props.to }>
        { props.value }
      </Link>
    </div>
  );
}
